import { getPartnerAccounts } from '../services/backendClient'

export const API_PARTNER_PROFILE = 'API_PARTNER'

export const getPartnerProfiles = () => ({
  type: API_PARTNER_PROFILE,
  promise: getPartnerAccounts()
})